// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3abll","title":"Info_title__1d_X7","links":"Info_links__VsiNU","link":"Info_link__2N9Es","logo":"Info_logo__24tP7"};